<ng-template #browser let-modal>
    @if (!isListOpen()) {
    <div class="modal-header d-flex flex-row justify-content-between align-items-center">
        <h2 class="modal-title text-center">{{'browser-attestations-details-modal-browser-title' | translate}}</h2>
        <button type="button" class="modal-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    } @else {
    <div class="modal-header d-flex flex-row justify-content-between align-items-center">
        <div class="d-flex flex-row align-items-center modal-back" type="button" (click)="back()">
            <button></button>
            <h3>{{'back' | translate}}</h3>
        </div>
        <h2 class="modal-title text-center">{{listTitle()}}</h2>
        <button type="button" class="modal-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    }
    <mat-divider></mat-divider>
    @if (!isListOpen()) {
    <div class="modal-body d-flex flex-column align-items-center">
        <div class="d-flex flex-column globalSettings">
            <div class="head d-flex flex-row align-items-center">
                <img src="assets/icons/ui.svg">
                <h3>{{'browser-attestations-details-modal-global-settings' | translate}}</h3>
            </div>
            <table class="table">
                <tbody>
                    <tr>
                        <th scope="row">
                            <h5>{{'browser-attestations-details-modal-browser-plugins' | translate}}</h5>
                        </th>
                        <td>
                            <button class="btn btn-outline-primary" (click)="getPluginsList()">
                                {{'see-the-list' | translate}}
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">
                            <h5>{{'browser-attestations-details-modal-browser-cookies-enabled' | translate}}</h5>
                        </th>
                        <td>
                            <h5>{{browserAttestation?.components?.cookiesEnabled}}</h5>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">
                            <h5>{{'browser-attestations-details-modal-browser-session-storage' | translate}}</h5>
                        </th>
                        <td>
                            <h5>{{browserAttestation?.components?.sessionStorage}}</h5>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">
                            <h5>{{'browser-attestations-details-modal-browser-local-storage' | translate}}</h5>
                        </th>
                        <td>
                            <h5>{{browserAttestation?.components?.localStorage}}</h5>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">
                            <h5>{{'browser-attestations-details-modal-browser-indexed-db' | translate}}</h5>
                        </th>
                        <td>
                            <h5>{{browserAttestation?.components?.indexedDB}}</h5>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">
                            <h5>{{'browser-attestations-details-modal-open-database' | translate}}</h5>
                        </th>
                        <td>
                            <h5>{{browserAttestation?.components?.openDatabase}}</h5>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="d-flex flex-column displaySettings">
            <div class="head d-flex flex-row align-items-center">
                <img src="assets/icons/BrowserAttestations/display.svg">
                <h3>{{'browser-attestations-details-modal-display-settings' | translate}}</h3>
            </div>
            <table class="table">
                <tbody>
                    <tr>
                        <th scope="row">
                            <h5>{{'browser-attestations-details-modal-browser-screen-frame' | translate}}</h5>
                        </th>
                        <td>
                            <h5>{{browserAttestation?.components?.screenFrame}}</h5>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">
                            <h5>{{'browser-attestations-details-modal-browser-forced-colors' | translate}}</h5>
                        </th>
                        <td>
                            <h5>{{browserAttestation?.components?.forcedColors}}</h5>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">
                            <h5>{{'browser-attestations-details-modal-browser-monochrome' | translate}}</h5>
                        </th>
                        <td>
                            <h5>{{browserAttestation?.components?.monochrome}}</h5>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">
                            <h5>{{'browser-attestations-details-modal-browser-reduced-motion' | translate}}</h5>
                        </th>
                        <td>
                            <h5>{{browserAttestation?.components?.reducedMotion}}</h5>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">
                            <h5>{{'browser-attestations-details-modal-browser-contrast' | translate}}</h5>
                        </th>
                        <td>
                            <h5>{{browserAttestation?.components?.contrast}}</h5>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    } @else {
    @if (listObject().length > 0) {
    <div class="modal-body listOpen">
        <app-commons-modal-part [listContent]="true" [listObject]="listObject()"></app-commons-modal-part>
    </div>
    } @else {
    <div class="modal-body">
        <app-loading-error [boolean]="false"
            [search]="'browser-attestations-details-modal-list-empty' | translate"></app-loading-error>
    </div>
    }
    }
</ng-template>

<ng-template #system let-modal>
    @if (!isListOpen()) {
    <div class="modal-header d-flex flex-row justify-content-between align-items-center">
        <h2 class="modal-title text-center">{{'browser-attestations-details-modal-system-title' | translate}}</h2>
        <button type="button" class="modal-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    } @else {
    <div class="modal-header d-flex flex-row justify-content-between align-items-center">
        <div class="d-flex flex-row align-items-center modal-back" type="button" (click)="back()">
            <button></button>
            <h3>{{'back' | translate}}</h3>
        </div>
        <h2 class="modal-title text-center">{{listTitle()}}</h2>
        <button type="button" class="modal-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    }
    <mat-divider></mat-divider>
    @if (!isListOpen()) {
    <div class="modal-body d-flex flex-column align-items-center">
        <div class="d-flex flex-column systemSettings">
            <div class="head d-flex flex-row align-items-center">
                <img src="assets/icons/BrowserAttestations/system.svg">
                <h3>{{'browser-attestations-details-modal-system-settings' | translate}}</h3>
            </div>
            <table class="table">
                <tbody>
                    <tr>
                        <th scope="row">
                            <h5>{{'browser-attestations-details-modal-system-device-memory' | translate}}</h5>
                        </th>
                        <td>
                            <h5>{{browserAttestation?.components?.deviceMemory}} Go</h5>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">
                            <h5>{{'browser-attestations-details-modal-system-hardware-concurrency' | translate}}</h5>
                        </th>
                        <td>
                            <h5>{{browserAttestation?.components?.hardwareConcurrency}} threads</h5>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">
                            <h5>{{'browser-attestations-details-modal-system-color-depth' | translate}}</h5>
                        </th>
                        <td>
                            <h5>{{browserAttestation?.components?.colorDepth}}</h5>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">
                            <h5>{{'browser-attestations-details-modal-system-color-gamut' | translate}}</h5>
                        </th>
                        <td>
                            <h5>{{browserAttestation?.components?.colorGamut}}</h5>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">
                            <h5>{{'browser-attestations-details-modal-system-max-touch-points' | translate}}</h5>
                        </th>
                        <td>
                            <h5>{{browserAttestation?.components?.touchSupport?.maxTouchPoints}}</h5>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">
                            <h5>{{'browser-attestations-details-modal-system-touch-event' | translate}}</h5>
                        </th>
                        <td>
                            <h5>{{browserAttestation?.components?.touchSupport?.touchEvent}}</h5>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">
                            <h5>{{'browser-attestations-details-modal-system-touch-start' | translate}}</h5>
                        </th>
                        <td>
                            <h5>{{browserAttestation?.components?.touchSupport?.touchStart}}</h5>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="d-flex flex-column displaySettings">
            <div class="head d-flex flex-row align-items-center">
                <img src="assets/icons/BrowserAttestations/display.svg">
                <h3>{{'browser-attestations-details-modal-display-settings' | translate}}</h3>
            </div>
            <table class="table">
                <tbody>
                    <tr>
                        <th scope="row">
                            <h5>{{'browser-attestations-details-modal-system-screen-resolution' | translate}}</h5>
                        </th>
                        <td>
                            <h5>
                                {{browserAttestation?.components?.screenResolution?.[0]}}x{{browserAttestation?.components?.screenResolution?.[1]}}
                            </h5>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">
                            <h5>{{'browser-attestations-details-modal-system-screen-hdr' | translate}}</h5>
                        </th>
                        <td>
                            <h5>{{browserAttestation?.components?.hdr}}</h5>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" class="align-middle">
                            <h5>{{'browser-attestations-details-modal-system-fonts' | translate}}</h5>
                        </th>
                        <td>
                            <button class="btn btn-outline-primary" (click)="getFontsList()">
                                {{'see-the-list' | translate}}
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" class="align-middle">
                            <h5>{{'browser-attestations-details-modal-system-fonts-preferences' | translate}}</h5>
                        </th>
                        <td>
                            <button class="btn btn-outline-primary" (click)="getFontsPreferencesList()">
                                {{'see-the-list' | translate}}
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" class="align-middle">
                            <h5>{{'browser-attestations-details-modal-system-languages' | translate}}</h5>
                        </th>
                        <td>
                            <button class="btn btn-outline-primary" (click)="getLanguagesList()">
                                {{'see-the-list' | translate}}
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    } @else {
    @if (listObject().length > 0) {
    <div class="modal-body listOpen">
        <app-commons-modal-part [listContent]="true" [listObject]="listObject()"></app-commons-modal-part>
    </div>
    } @else {
    <div class="modal-body">
        <app-loading-error [boolean]="false"
            [search]="'browser-attestations-details-modal-list-empty' | translate"></app-loading-error>
    </div>
    }
    }
</ng-template>

<button class="btn btn-lg btn-outline-primary" (click)="open()">{{'see-more' | translate}}</button>